import React from "react";
import { Bar, ButtonsWrapper, LogoWrapper } from "./TopBarStyles";

export const TopBar = () => {
  return (
    <Bar>
      <LogoWrapper>
        <span></span>
      </LogoWrapper>
      <ButtonsWrapper></ButtonsWrapper>
    </Bar>
  );
};
